import { getDispensaryApiBaseUrl } from "./api-base";

export async function fetchWithClerkJwt(
  getToken: () => Promise<string | null>,
  path: string,
  init: RequestInit = {},
): Promise<Response> {
  const jwt = await getToken();
  if (!jwt) {
    throw new Error("clerk_session_missing");
  }
  const base = getDispensaryApiBaseUrl();
  const url = base ? `${base}${path}` : path;
  const headers = new Headers(init.headers);
  headers.set("Authorization", `Bearer ${jwt}`);
  return fetch(url, { ...init, headers });
}
